import SingleButton, { getClassName, getDisabledClassName } from '@/components/SingleButton';
import { TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { getContent } from '@/utils/tools';
import { addDialogue } from '@/utils/sessionUtils';
// import uploadMessageToSave from '@/utils/uploadMessageToSave';
import { inject, observer } from 'mobx-react';

import Msg from '@/components/Msg';
import React from 'react';
import { handleRedirectionBtnClick } from '@/utils/btnClickHandler';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';

// import './style.scss';

const PREFIX = 'redirection-container';

@tracker
@inject(getChildInject('initStore'))
@observer
export default class Redirection extends React.PureComponent {
  static defaultProps = {
    // props
    msgContent: '',
    buttons: [],
    dialogueId: '',
    dialogueType: '',
    disabledBtn: false,
    // stores
    initStore: {}
  };

  constructor(props) {
    super(props);

    this.trackingname = TRACKING_TYPE.STANDARDIZE_BUTTON;
  }

  handleJumpClick = (button = {}) => () => {
    const {
      dialogueId,
      dialogueType,
      initStore,
      nodePointId,
      isHistory,
      historyDialogueId,
      historySessionId
    } = this.props;
    const { button_type, button_id } = button;

    if (!isHistory) {
      addDialogue({
        dialogueId,
        dialogueType,
        from: 'user',
        type: 'Msg',
        data: { content: getContent(button) }
      });

      // 暂时不传Redirection
      // uploadMessageToSave({
      //   dialogueId,
      //   messages: [{
      //     message_text: getContent(button),
      //     is_sent_by_user: true
      //   }]
      // });
    }

    handleRedirectionBtnClick({
      ...button,
      isHistory
    }, {
      trackingname: this.trackingname,
      trackingdata: {
        node_point_id: nodePointId,
        chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
        chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
        button_text: getContent(button),
        button_type,
        button_id,
        if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME
      }
    });
  };

  renderButton = (button, index) => {
    const {
      dialogueId,
      listPos,
      initStore,
      passedRef,
      nodePointId,
      disabledBtn,
      isHistory,
      historyDialogueId,
      historySessionId
    } = this.props;
    const { button_type, button_id } = button;
    const btnClassName = disabledBtn ? getDisabledClassName(button.style) : getClassName(button.style);

    const trackingdata = JSON.stringify({
      node_point_id: nodePointId,
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      button_details: [{
        button_text: getContent(button),
        button_type,
        button_id
      }],
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME
    });

    return <SingleButton
      trackingname={this.trackingname}
      trackingindex={`${listPos}-${index}`}
      trackingdata={trackingdata}
      key={`button-${index}`}
      passedRef={(ele) => passedRef(ele, index)}
      text={getContent(button)}
      handleClick={this.handleJumpClick(button)}
      className={btnClassName}
    />;
  }

  render() {
    const {
      msgContent,
      buttons,
    } = this.props;

    return <div className={PREFIX}>
      <Msg content={msgContent} />
      {
        buttons.map((button, index) => this.renderButton(button, index))
      }
    </div>;
  }
}
